import dayjs from 'dayjs';
import 'dayjs/locale/nl';
import localizedFormat from "dayjs/plugin/localizedFormat";

dayjs.locale('nl');
dayjs.extend(localizedFormat);


export default dayjs;
